module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABKUlEQVQ4T9WUsUvDQBTGv5c6CeJ/UHJdBFddvOJscRUXXdzF1cGapuGKIO7dBd26Ozgp5ETp7tZYwdFRkCTNK9qklpqUSLN4cPC4996P9717d2Q6skkGbMyxOIJDQkmegzFOpcIqKqKaLwb9L9DKeXXJ93ELcIUjtF9s3cxSMFOaUPIDwGKSTIzDXkO302CZIFNtdAm0NpX0CcKWd6rvp2GpIKHkFYD9VBmErm+EtbeTp/dJ/y+QULIOoDX7NvnSsx4OMkGVltxhRiffSNCxZ7kX4/4lRvlsc7U0GGgAy/lAQGTQdr/u3vwMpA1DLMhHAOt5IXHcM4VU6znu63ePTFW9JvDeHyFJeMez9G5xj7bob+QobnIAIIx3Ygfg0RkTAhr5J+I45IjuhouSZjkqhis5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/paixu/ding.png
// module id = 7XS/
// module chunks = 3